import React from 'react';
import { Screen } from '../ui/Screen';
import { ProgressCircle } from '../ui/ProgressCircle';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { CheckCircleIcon, PlayIcon, SunriseIcon, AwardIcon, BookOpenIcon, StarIcon, HeartIcon, BarChart4Icon, PaletteIcon, LayoutIcon } from 'lucide-react';
export const UIFlowSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-1447">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-4 border-l-4 border-[#d4af37] pl-4" data-id="element-1448">
        Gamification in de Gebruikersinterface
      </h2>
      <div className="flex items-center mb-4" data-id="element-1449">
        <LayoutIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-1450" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-1451">
          De gebruikersinterface toont gamification-elementen die consistent
          inchecken aanmoedigen en de voortgang visualiseren.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 justify-items-center" data-id="element-1452">
        {/* Dagstart Scherm */}
        <Screen title="Dagstart" description="Gamification via voortgangscirkel" data-id="element-1453">
          <div className="h-full flex flex-col items-center justify-between py-4" data-id="element-1454">
            <div className="flex flex-col items-center" data-id="element-1455">
              <div className="mb-2" data-id="element-1456">
                <Badge label="Balansreeks: Dag 4/7" icon={<AwardIcon className="w-3 h-3" data-id="element-1458" />} data-id="element-1457" />
              </div>
              <SunriseIcon className="w-8 h-8 text-[#d4af37] mb-3" data-id="element-1459" />
              <ProgressCircle progress={0.8} data-id="element-1460">
                <span className="text-base font-light text-[#d4af37]" data-id="element-1461">80%</span>
              </ProgressCircle>
            </div>
            <div className="text-center" data-id="element-1462">
              <h4 className="text-base font-light text-[#333333] mb-2" data-id="element-1463">
                Goedemorgen, Anna
              </h4>
              <p className="text-xs text-[#666666] mb-2" data-id="element-1464">
                Nog één moment voor jezelf en je dag is compleet.
              </p>
              <p className="text-xs text-[#888888] mb-4" data-id="element-1465">
                Dag 4 van je balansreeks
              </p>
              <Button data-id="element-1466">Check in</Button>
            </div>
          </div>
        </Screen>
        {/* Bijna-doel Scherm */}
        <Screen title="Bijna-doel" description="Gamification via beloningsvooruitzicht" data-id="element-1467">
          <div className="h-full flex flex-col items-center justify-between py-4" data-id="element-1468">
            <div className="flex flex-col items-center" data-id="element-1469">
              <div className="mb-2" data-id="element-1470">
                <Badge label="Niveau 2: Stressreductie" variant="filled" icon={<BookOpenIcon className="w-3 h-3" data-id="element-1472" />} data-id="element-1471" />
              </div>
              <ProgressCircle progress={0.95} data-id="element-1473">
                <span className="text-base font-light text-[#d4af37]" data-id="element-1474">95%</span>
              </ProgressCircle>
            </div>
            <div className="text-center" data-id="element-1475">
              <h4 className="text-base font-light text-[#333333] mb-2" data-id="element-1476">
                Je weekbalans is bijna rond
              </h4>
              <p className="text-xs text-[#666666] mb-3" data-id="element-1477">
                Nog 1 check-in voor je mijlpaal
              </p>
              <div className="bg-[#f7f3ef] p-2 rounded-lg mb-4" data-id="element-1478">
                <div className="flex items-center justify-center mb-1" data-id="element-1479">
                  <AwardIcon className="w-3 h-3 text-[#d4af37] mr-1" data-id="element-1480" />
                  <p className="text-xs text-[#888888]" data-id="element-1481">Bijna vrijgespeeld</p>
                </div>
                <div className="flex items-center" data-id="element-1482">
                  <div className="w-5 h-5 rounded-full bg-[#f7f3ef] border border-[#d4af37] flex items-center justify-center mr-1" data-id="element-1483">
                    <BarChart4Icon className="w-2.5 h-2.5 text-[#d4af37]" data-id="element-1484" />
                  </div>
                  <p className="text-xs text-[#666666]" data-id="element-1485">Weekbalans Inzicht</p>
                </div>
              </div>
              <Button data-id="element-1486">Doe oefening</Button>
            </div>
          </div>
        </Screen>
        {/* Doel behaald Scherm */}
        <Screen title="Doel behaald" description="Gamification via beloningen" data-id="element-1487">
          <div className="h-full flex flex-col items-center justify-between py-4" data-id="element-1488">
            <div className="flex flex-col items-center" data-id="element-1489">
              <div className="mb-2" data-id="element-1490">
                <Badge label="Mijlpaal bereikt!" variant="filled" icon={<AwardIcon className="w-3 h-3" data-id="element-1492" />} data-id="element-1491" />
              </div>
              <CheckCircleIcon className="w-8 h-8 text-[#d4af37] mb-3" data-id="element-1493" />
              <ProgressCircle progress={1} data-id="element-1494">
                <span className="text-base font-light text-[#d4af37]" data-id="element-1495">
                  100%
                </span>
              </ProgressCircle>
            </div>
            <div className="text-center" data-id="element-1496">
              <h4 className="text-base font-light text-[#333333] mb-1" data-id="element-1497">
                Mooi gedaan, Anna
              </h4>
              <p className="text-xs text-[#666666] mb-1" data-id="element-1498">
                Je hebt je weekbalans-mijlpaal behaald.
              </p>
              <p className="text-xs text-[#888888] mb-2" data-id="element-1499">
                Je balansreeks is nu 7 dagen lang
              </p>
              <div className="bg-[#f7f3ef] p-2 rounded-lg mb-4" data-id="element-1500">
                <div className="flex items-center justify-center mb-1" data-id="element-1501">
                  <BookOpenIcon className="w-3 h-3 text-[#d4af37] mr-1" data-id="element-1502" />
                  <p className="text-xs text-[#888888]" data-id="element-1503">Vrijgespeeld</p>
                </div>
                <div className="flex items-center" data-id="element-1504">
                  <div className="w-5 h-5 rounded-full bg-[#f7f3ef] border border-[#d4af37] flex items-center justify-center mr-1" data-id="element-1505">
                    <BarChart4Icon className="w-2.5 h-2.5 text-[#d4af37]" data-id="element-1506" />
                  </div>
                  <p className="text-xs text-[#666666]" data-id="element-1507">Weekbalans Inzicht</p>
                </div>
              </div>
              <Button data-id="element-1508">
                <div className="flex items-center" data-id="element-1509">
                  <PlayIcon className="w-3 h-3 mr-1" data-id="element-1510" />
                  Bekijk inzichten
                </div>
              </Button>
            </div>
          </div>
        </Screen>
        {/* Positieve Benadering Scherm */}
        <Screen title="Positieve Benadering" description="Gamification zonder schuldgevoel" data-id="element-1511">
          <div className="h-full flex flex-col items-center justify-between py-4" data-id="element-1512">
            <div className="flex flex-col items-center" data-id="element-1513">
              <div className="mb-2" data-id="element-1514">
                <Badge label="Je prestatie telt!" variant="filled" icon={<StarIcon className="w-3 h-3" data-id="element-1516" />} data-id="element-1515" />
              </div>
              <div className="relative mb-3" data-id="element-1517">
                <ProgressCircle progress={0.6} color="#d4af37" backgroundColor="#f7f3ef" data-id="element-1518">
                  <span className="text-base font-light text-[#d4af37]" data-id="element-1519">6</span>
                </ProgressCircle>
                <div className="absolute -top-1 -right-1" data-id="element-1520">
                  <div className="w-6 h-6 rounded-full bg-[#f7f3ef] border-2 border-[#d4af37] flex items-center justify-center" data-id="element-1521">
                    <HeartIcon className="w-3 h-3 text-[#d4af37]" data-id="element-1522" />
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-1523">
              <h4 className="text-base font-light text-[#333333] mb-2" data-id="element-1524">
                Indrukwekkende reeks!
              </h4>
              <p className="text-xs text-[#666666] mb-3" data-id="element-1525">
                6 dagen achter elkaar voor jezelf zorgen is een knappe
                prestatie.
              </p>
              <div className="bg-[#f7f3ef] p-2 rounded-lg mb-4" data-id="element-1526">
                <div className="flex items-center justify-center mb-1" data-id="element-1527">
                  <StarIcon className="w-3 h-3 text-[#d4af37] mr-1" data-id="element-1528" />
                  <p className="text-xs text-[#888888]" data-id="element-1529">
                    Voortgang blijft behouden
                  </p>
                </div>
                <p className="text-xs text-[#666666]" data-id="element-1530">
                  Probeer de 'Rust in 3 minuten'-oefening
                </p>
              </div>
              <Button data-id="element-1531">Start oefening</Button>
            </div>
          </div>
        </Screen>
      </div>
    </div>;
};